var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.6665V10.6665L13.3333 15.9998L8 21.3332V29.3332H24V21.3332L18.6667 15.9998L24 10.6665V2.6665H8ZM21.3333 21.9998V26.6665H10.6667V21.9998L16 16.6665L21.3333 21.9998ZM16 15.3332L10.6667 9.99984V5.33317H21.3333V9.99984L16 15.3332Z",
    fill: "#2464EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H12L16 13L20 9Z",
    fill: "#2464EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V8.5C11.7978 8.5 11.6155 8.62182 11.5381 8.80866C11.4607 8.9955 11.5034 9.21055 11.6464 9.35355L12 9ZM20 9L20.3536 9.35355C20.4966 9.21055 20.5393 8.9955 20.4619 8.80866C20.3845 8.62182 20.2022 8.5 20 8.5V9ZM16 13L15.6464 13.3536L16 13.7071L16.3536 13.3536L16 13ZM12 9.5H20V8.5H12V9.5ZM19.6464 8.64645L15.6464 12.6464L16.3536 13.3536L20.3536 9.35355L19.6464 8.64645ZM16.3536 12.6464L12.3536 8.64645L11.6464 9.35355L15.6464 13.3536L16.3536 12.6464Z",
    fill: "#2464EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesaving);
export default __webpack_public_path__ + "static/media/Timesaving.1d6f5318c2ba7e757195647b2ec9d69a.svg";
export { ForwardRef as ReactComponent };